const GetEGenderName = (id) => {
    switch (id) {
        case 0: { return "Male" }
        case 1: { return "Female" }
    }
}

const GetEGender = {
    EGender: [
        { Id: 0, Name: "Male" },
        { Id: 1, Name: "Female" },
    ]
}

export { GetEGenderName, GetEGender }
